<script setup lang="ts">
import { Button } from '@forgd/ui-kit/button'
import { ShieldCheckIcon } from '@heroicons/vue/24/outline'

const props = defineProps<{
  marketMakerId: string
}>()

const claimRoute = computed(() => `/market-maker-leaderboard/claim?marketMakerId=${encodeURIComponent(props.marketMakerId)}`)
</script>

<template>
  <CoreGradientBanner
    data-el="LClaimOrganizationBanner"
    class="rounded-lg"
  >
    <div class="flex items-start gap-3 p-5">
      <ShieldCheckIcon class="size-5 shrink-0 text-white" />
      <div class="flex flex-col items-start gap-3">
        <h3 class="text-sm font-semibold text-white">
          Claim this organization
        </h3>
        <p class="text-sm text-white">
          Claimed organizations have better chance to improve the leaderboard score. Join Forgd today, complete your profile details, and start tracking your activity.
        </p>
        <Button variant="outline-inverted" size="md" as-child>
          <NuxtLink :to="claimRoute">
            Claim Organization
          </NuxtLink>
        </Button>
      </div>
    </div>
  </CoreGradientBanner>
</template>
